import request from '../utils/request'
const base = 'external-token'

/**
 * @method getAuthToken
 * @param {String} folio - Folio
 * @param {Number} v - API Version
 */

export function getAuthToken(phone, countryCode, v) {
  return request({
    url: `auth/v${v || 1}/${base}`,
    baseURL: process.env.VUE_APP_API,
    method: 'post',
    data: {
      client_id: process.env.VUE_APP_CLIENT_ID,
      grant_type: process.env.VUE_APP_GRANT_TYPE,
      countryCode,
      phone
    }
  })
}

export function getAuthTokenByFolio(folio, ws, v) {
  return request({
    url: `auth/v${v || 1}/${base}`,
    baseURL: process.env.VUE_APP_API,
    method: 'post',
    data: {
      client_id: process.env.VUE_APP_CLIENT_ID,
      grant_type: process.env.VUE_APP_GRANT_TYPE,
      folio,
      ws: ws
    }
  })
}
